<template>
  <div class="page-effect">
    <!-- <section
      id="sectionId"
      class="ss-reg-top"
      style="background-color: #f1f3f4"
    > -->
    <div class="container-fluid border-bottom p-0 ss-reg-top">
     
    
      <div class="d-md-flex justify-content-end page-option-sticky sticky-without-menu">
        <a
          href="#"
          class="pt-3 left-effect2"
          data-toggle="modal"
          data-target="#welcomemailModalCenter"
          @click="
            $refs.reminderAnnounceMailPopup.getMailTemplate('ReminderMail')
          "
        >
          <v-icon color="#5f6368" size="18px" class="mr-1"
            >mdi-email-outline</v-icon
          >
          Send Mail</a
        >

        <a
          id="v-step-com"
          href="#"
          class="pt-3 left-effect2 d-none"
          ><v-icon color="#5f6368" size="18px" class="mr-1"
            >mdi-cog-outline</v-icon
          >
          Advanced Settings</a
        >

        <a
          href="#"
          class="pt-3 left-effect2"
          data-toggle="modal"
          data-target="#CheckoutformypeModal"
          @click="openBulkUploadPopup()"
          ><v-icon color="#5f6368" size="18px" class="mr-1"
            >mdi-tray-arrow-up</v-icon
          >
          Bulk Import</a
        >

        <v-btn
          class="my-2 mr-4 save-standard"
          outlined
          color="#2376e5"
          width="180px"
          @click="openAttendeePopup()"
          ><v-icon id="v-step-0" class="mr-1" color="#2376e5" size="20px"
            >mdi-plus</v-icon
          >
          Add New Attendee</v-btn
        >
      </div>

      <div>
        
        <!-- @onUpdate="onUpdate" -->
        <AttendeeList
          ref="attendeeList"
          :key="attendeeListKey"
          :isAdminComponent="isAdminComponent"
          @OpenAddAttendeePopup="OpenAddAttendeePopup"
        >
        </AttendeeList>        
      </div>
    </div>
    <!-- </section> -->
    <!-- Add new attendee Modal -->

    <!-- <v-dialog
      v-model="attendeeAddEditDialog"
      persistent
      content-class="modal-content"
      transition="scroll-x-reverse-transition"
      style=""
    >
      <v-card-text
        class="ex-dialog-body px-0"
        style="p-0;font-size:1rem; padding:0; position: relative"
      >
        <div style="position: absolute; right: 10px; top: 10px; width: 32px">
          <v-icon style="z-index: 2" size="32" @click="CloseAddAttendeePopup()"
            >close</v-icon
          >
        </div>
        <div class="modal-content">
        <AttendeeAddEdit
          :key="attendeeAddEditKey"
          ref="attendeeAddEditK"
          :Attendee="Attendee"
        ></AttendeeAddEdit>
        </div>
      </v-card-text>
    </v-dialog> -->
    <AttendeeAddEdit
      v-if="attendeeAddEditDialog"
      ref="attendeeAddEditPopUp"
      :key="attendeeAddEditKey"
      :uid="uid"
      :clientId="clientId"
      :eventId="eventId"
      :event_collectionName="event_collectionName"
      :Attendee="Attendee"
      @OnAddAttendeeSuccess="OnAddAttendeeSuccess"
      @OnUpdateAttendeeSuccess="OnUpdateAttendeeSuccess"
    ></AttendeeAddEdit>
    <!-- Add new attendee Modal -->

    <ReminderAnnounceMailPopup ref="reminderAnnounceMailPopup" />
    <BulkUpload
      v-if="openBulkPopup"
      :key="resetBulkUploadComponent"
      type="attendee"
    />

    <!-- <div
      id="attendeeAddEditSuccess"
      class="modal fade ss-success-modal"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <img src="../assets/Images/reg-ico/success.png" alt="e2m" />
            <h2 class="my-5">
              The new attendee has been created successfully!
            </h2>
            <div class="ss-cns-foo-btn final-button">
              <v-btn outlined large color="#1a73e8" class="mr-2" @click="$router.push('/overview')"
                ><v-icon color="#1a73e8" size="20px" class="mr-4"
                  >mdi-arrow-left</v-icon
                >
                Back to overview</v-btn
              >
              <v-btn
                large
                color="#1a73e8"
                dark
                class="px-4"
                @click="CloseSuccess"
              >
                Great
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    
    <v-dialog
      max-width="600"
      scrollable
      v-model="attendeeAddEditSuccess"
      persistent
      content-class="modal-content"
      transition="scroll-x-reverse-transition"
      style=""
    >
      <!-- <v-card class="modal fade ss-success-modal"> -->

        <v-card-text>
          <div class="modal-content">
            <div class="modal-body text-center">
              <img src="../assets/Images/reg-ico/success.png" alt="e2m" />
              <h2 class="my-5">
                The new attendee has been created successfully!
              </h2>
              <div class="ss-cns-foo-btn final-button">
                <v-btn
                  outlined
                  large
                  color="#1a73e8"
                  class="mr-2"
                  @click="CloseSuccess"
                  >
                  Close</v-btn
                >
                <v-btn
                  large
                  color="#1a73e8"
                  dark
                  class="px-4"
                  @click="CloseSuccess"
                >
                  Great
                </v-btn>
              </div>
            </div>
          </div>
        </v-card-text>
      <!-- </v-card> -->
      
    </v-dialog>

    <span id="v-step-end" style="display: none"></span>
    <div class="custom-v-tour">
      <v-tour
        name="adminAttendeeListTour"
        :steps="steps"
        :options="tourOptions"
        :callbacks="tourCallbacks"
      ></v-tour>
    </div>

    
  </div>
</template>
<script>
// import db from "../components/firebaseInit";
import axios from "axios";
import APIs from "@/components/APIInit";
import router from "../router";
import jQuery from "jquery";
let $ = jQuery;

import AttendeeList from "@/views/AttendeeList.vue";
import AttendeeAddEdit from "@/views/AttendeeAddEdit.vue";

var vm;
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import ReminderAnnounceMailPopup from "@/views/ReminderAnnounceMailPopup.vue";
import BulkUpload from "@/views/BulkUpload.vue";
import store from "../store";
import VueTour from "vue-tour";

require("vue-tour/dist/vue-tour.css");
// import axios from "axios";
import { bus } from "@/main";
Vue.use(VueMoment, {
  moment,
});
Vue.use(VueTour);

export default {
  components: {
    AttendeeList,
    AttendeeAddEdit,
    ReminderAnnounceMailPopup,
    BulkUpload,
  },
  data() {
    return {
      attendeeAddEditSuccess: false,
      tourOptions: {
        labels: {
          buttonSkip: "Skip",
          buttonPrevious: "Previous",
          buttonNext: "Next",
          buttonStop: "Finish",
        },
      },
      tourCallbacks: {
        onNextStep: this.onTourFinish,
      },
      steps: [
        {
          target: "#v-step-0", // We're using document.querySelector() under the hood
          header: {
            title: "Add Attendees:",
          },
          content: `Create a new attendee`,
          params: {
            placement: "bottom",
            positionFixed: true,
          },
        },

        {
          target: "#v-step-end",
          header: {
            title: "View Attendees1:",
          },
          content: "Review Attendees and edit them",
          params: {
            placement: "bottom",
            positionFixed: true,
          },
        },
        // {
        //   target: "#v-step-2",
        //   header: {
        //     title: "Advanced Settings:",
        //   },
        //   content: "Advanced settings for nerds! :)",
        //   params: {
        //     placement: "bottom",
        //     positionFixed: true,
        //   },
        // },
      ],
      uid: "",
      clientId: "",
      eventId: "",
      event_collectionName: "",
      isAdminComponent: true,
      attendeeListKey: 0,
      attendeeAddEditKey: 0,
      attendeeAddEditDialog: false,
      // BannerURL: "",
      // mobileBanner: "",
      // desktopBanner: "",
      Attendee: {},
      openBulkPopup: false,
      resetBulkUploadComponent: 0,
      drawer: null,
    };
  },
  computed: {},
  watch: {},
  created() {
    vm = this;
    //vm.initScreen();
    // $(window).resize(function () {
    //   vm.initScreen();
    // });
    
    
      bus.$on("openAddAttendeeDialog", () => {
        vm.openAttendeePopup();
    });
  },
  mounted() {
    vm.uid = vm.getSessionUserId();
    vm.clientId = vm.getClientId();
    vm.eventId = vm.getEventId();
    vm.event_collectionName = vm.getEventCollectionName();

    if (vm.isAdminComponent) {
      setTimeout(() => {
        if (
          !vm.$store.getters.getAdminTour ||
          !vm.$store.getters.getAdminTour.includes("Attendee")
        ) {
          if (vm.$store.getters.adminTourSeen) {
            store.commit(
              "setAdminTour",
              vm.$store.getters.adminTourSeen + ",Attendee"
            );
          } else {
            store.commit("setAdminTour", "Attendee");
          }
          vm.$tours["adminAttendeeListTour"].start();
        }
      }, 2000);
    }

    bus.$on("complete-attendee-tour", (flag) => {
      if (flag) {
        vm.steps.pop();
        vm.steps.splice(1, 0, {
          target: "#v-step-com",
          header: { title: "Advanced Settings:" },
          offset: -200,
          params: { placement: "bottom", positionFixed: true },
          content: "Advanced settings for nerds! :)",
        });
        if (vm.isAdminComponent) {
          setTimeout(() => {
            vm.$tours["adminAttendeeListTour"].start();
          }, 1000);
        }
      }
    });

    if (vm.$route.hash == "#create") {
      vm.openAttendeePopup();
    }
  },
  methods: {
    onTourFinish() {
      vm.steps.pop();
      bus.$emit("start-attendee-tour", true);
    },
    // initScreen() {
    //   if (window.innerWidth > 768) {
    //     vm.BannerURL = vm.desktopBanner;
    //   } else {
    //     vm.BannerURL = vm.mobileBanner;
    //   }
    // },
    openAttendeePopup() {
      // vm.$emit("OpenAddAttendeePopup");
      vm.OpenAddAttendeePopup();
    },
    openBulkUploadPopup() {
      vm.openBulkPopup = true;
      vm.resetBulkUploadComponent += 1;
    },
    goForLogin: function () {
      router.push({ name: "Login" });
    },
    OpenAddAttendeePopup(data) {
      this.Attendee = data;
      vm.attendeeAddEditDialog = true;
      vm.attendeeAddEditKey += 1;
      this.$nextTick(() => {
        $("#attendeeAddEdit").modal("show");
      });
    },
    CloseAddAttendeePopup() {
      vm.attendeeAddEditKey += 1;
      vm.attendeeAddEditDialog = false;
      $("#attendeeAddEdit").modal("hide");
    },
    OnAddAttendeeSuccess() {
      vm.CloseAddAttendeePopup();
      vm.OpenSuccess();
    },
    OnUpdateAttendeeSuccess() {
      vm.CloseAddAttendeePopup();
      vm.CloseSuccess();
      vm.showSnackbar("Attendee Updated Succesfully", "success", "top");
    },
    OpenSuccess() {
      //$("#attendeeAddEditSuccess").modal("show");
      vm.attendeeAddEditSuccess = true;
    },
    CloseSuccess() {
      vm.attendeeAddEditSuccess = false;
      //$("#attendeeAddEditSuccess").modal("hide");
      vm.attendeeListKey += 1;
    },
    updateAttendeeData(field){
      bus.$emit("toggleLoader", true);
      let headers = {
          "Content-Type": "application/json",
          Authorization: "Bearer " + vm.getSessionToken(),
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: vm.clientId,
            eventId: vm.eventId,
          },
          data: field,
        };
        axios
          .post(APIs.UpdateSingleAttendee, requestData, { headers: headers })
          .then(function (res) {
            bus.$emit("toggleLoader", false);            
            if (res.status == 200) {                    
              vm.showSnackbar("Attendee updated successfully.", "success", "top");
            } else {
              vm.showSnackbar("Data not updated!", "error", "top");
            }
          })
          .catch(function () {
            bus.$emit("toggleLoader", false);
            vm.showSnackbar("Something went wrong", "error", "top");
          });
    },
  },
};
</script>
<style>
.custom-v-tour .v-step__header {
  background: #19191d !important;
  color: #fff !important;
  position: relative !important;
}
.custom-v-tour .v-step {
  background: #19191d !important;
  color: #dfdfdf !important;
  font-size: 16px !important;
  border: 1px solid #b5b5b5 !important;
  padding: 25px 30px;
}

.custom-v-tour .v-step__header:after {
  content: "";
  position: absolute;
  width: 95%;
  height: 1px;
  background: #2a2a2f;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
}

.custom-v-tour .v-step__button.v-step__button-skip,
.custom-v-tour .v-step__button.v-step__button-previous {
  border: none !important;
  background: #393a3e !important;
  color: #fff !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  border-radius: 2px !important;
  height: 35px !important;
  width: 70px !important;
}

.custom-v-tour .v-step .v-step__arrow {
  border-color: #b5b5b5 !important;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
}
.custom-v-tour .v-step__button.v-step__button-next,
.custom-v-tour .v-step__button.v-step__button-stop {
  border: none !important;
  background: #2376e5 !important;
  color: #fff !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  border-radius: 2px !important;
  height: 35px !important;
  width: 70px !important;
}
</style>